module.exports = __webpack_public_path__ + "8dd1e1182853d17cb0da9ca0809184f7.svg";